"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedcomponents = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.text-info"));

var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.simple-form"));

var _gerenciatdUnifiedcomponents3 = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.input"));

var _gerenciatdUnifiedicons = _interopRequireWildcard(require("@bit/gerenciatd.unifiedicons.svg-icon-loader"));

require("./NotFound.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class NotFound extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "handleSearch", () => {
      const {
        query
      } = this.state;
      const urlToRedirect = `https://atencionalcliente.movistar.es/?q=${query}`;
      window.location.href = urlToRedirect;
    });

    _defineProperty(this, "setQuery", query => {
      this.setState({
        query
      });
    });

    this.state = {
      query: ''
    };
  }

  render() {
    const {
      taggingInfo
    } = this.props;
    const icon2Input = {
      id: _gerenciatdUnifiedicons.ICONS_ID.Buscar,
      kind: _gerenciatdUnifiedicons.SVG_ICON_KIND.MEDIUM,
      color: _gerenciatdUnifiedicons.COLOR.BLACK
    };
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "NotFoundContent",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        text: "404",
        level: _gerenciatdUnifiedcomponents.HEADING_LEVEL.H2,
        kind: _gerenciatdUnifiedcomponents.KIND_TEXT.HEADING,
        align: _gerenciatdUnifiedcomponents.ALIGN.CENTER,
        color: _gerenciatdUnifiedcomponents.COLOR.WHITE,
        size: _gerenciatdUnifiedcomponents.SIZE.DISPLAY2,
        fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.THIN
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        text: "Lo sentimos, esta p\xE1gina no existe",
        kind: _gerenciatdUnifiedcomponents.KIND_TEXT.PARAGRAPH,
        align: _gerenciatdUnifiedcomponents.ALIGN.CENTER,
        color: _gerenciatdUnifiedcomponents.COLOR.WHITE,
        size: _gerenciatdUnifiedcomponents.SIZE.TITLE3,
        fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.LIGHT
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, {
        method: "get",
        onSubmit: this.handleSearch,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
          id: "notFound-input",
          name: "searchHelp",
          actionInput: this.handleSearch,
          svgIconProps: icon2Input,
          theme: _gerenciatdUnifiedcomponents3.THEME.ROUNDED,
          onChange: this.setQuery,
          placeHolder: "\xBFQu\xE9 est\xE1s buscando?",
          taggingInfo: taggingInfo,
          cleanButton: true,
          SvgIconLoader: _gerenciatdUnifiedicons.default
        })
      })]
    });
  }

}

var _default = NotFound;
exports.default = _default;

//# sourceMappingURL=index.js.map